export function safePlan(plan, fields, dateFields) {
  if (!plan || !['count', 'group_count'].includes(plan.operation) || !Array.isArray(plan.filters) || plan.filters.length > 4) throw new Error('Unsupported plan');
  const allowed = new Set(fields.map(f => f.field));
  if (plan.operation === 'group_count' && !allowed.has(plan.group_by)) throw new Error('Unsupported grouping');
  if (plan.operation === 'count' && plan.group_by != null) throw new Error('Unexpected grouping');
  const used = new Set();
  const filters = plan.filters.map(f => {
    if (!allowed.has(f.field) || used.has(f.field) || !['eq', 'is_null'].includes(f.operator)) throw new Error('Unsupported filter');
    used.add(f.field);
    if (f.operator === 'eq' && (typeof f.value !== 'string' || !f.value.trim() || f.value.length > 100)) throw new Error('Missing filter value');
    return { field: f.field, operator: f.operator, ...(f.operator === 'eq' ? { value: f.value } : {}) };
  });
  const result = { operation: plan.operation, ...(plan.operation === 'group_count' ? { group_by: plan.group_by } : {}), filters };
  if (plan.date_filter) {
    const d = plan.date_filter;
    if (!dateFields.some(f => f.field === d.field) || d.period !== 'custom' || !/^\d{4}-\d{2}-\d{2}$/.test(d.start || '') || !/^\d{4}-\d{2}-\d{2}$/.test(d.end || '') || d.start > d.end) throw new Error('Unsupported date filter');
    result.date_filter = { field: d.field, period: 'custom', start: d.start, end: d.end };
  }
  return result;
}

// All free-text questions go to Ubuntu; existing click/page operations remain typed reads.
export async function answerPatientQuestion({api,question,previousSummary,signal}) {
 const payload={operation:'agent_chat',question,...(previousSummary?.agent_context?{agent_context:previousSummary.agent_context}:{})};
 const {data}=await api.post('/mitracare-ai/database/query',payload,{signal,timeout:125000});
 if(!data||typeof data.answer!=='string'||typeof data.kind!=='string')throw new Error('Invalid agent chat response');
 if(data.phase==='review'||data.kind==='query_review')throw new Error('Unexpected query review');
 return data;
}
